import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "h-100" }

import {computed, getCurrentInstance, nextTick, onBeforeUnmount, onMounted, ref, watch} from 'vue';
import WindowHelper from "~/ts/library/WindowHelper";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import Delay from "~/ts/library/Delay";
import InfiniteScrollContainerExposeInterface from "~/core-ui/vue/InfiniteScrollContainerExposeInterface";


const __default__ = {
    name: "InfiniteScrollContainer"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    loadMethod: {},
    scrollContainer: {},
    active: { type: Boolean, default: true },
    loadPreviousLabel: {},
    items: {},
    scrollDirection: { default: "top" }
  },
  emits: ["scrolled-to-bottom"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit

let isScrolledToBottom = ref(true);

let loading = ref(false);
let scrollHandler = ref<() => void>();

let loadAvailable = ref(true);


let itemsCountHandlerEnabled = ref(true);

let isFirstLoad = props.items.length == 0;

let itemsCount = computed(() => {
    return props.items.length;
});

watch(itemsCount, () => {
    if (isScrolledToBottom.value && itemsCountHandlerEnabled.value) {
        WindowHelper.scrollToBottom(props.scrollContainer, 100);
    }
});

onMounted(() => {
    if (props.scrollContainer) {
        if (isFirstLoad || props.scrollContainer.clientHeight >= props.scrollContainer.scrollHeight) {
            loadMore();
        } else {
            if (props.scrollDirection == "top") {
                props.scrollContainer.scrollTop = props.scrollContainer.scrollHeight;
                setTimeout(() => {
                    props.scrollContainer.scrollTop = props.scrollContainer.scrollHeight;
                }, 100);
            }
        }
        scrollHandler.value = () => {
            let container = props.scrollContainer;
            isScrolledToBottom.value = container.scrollTop + container.clientHeight > container.scrollHeight - 50;
            emits("scrolled-to-bottom", isScrolledToBottom.value);
            if (props.active) {
                let needLoad = (
                    props.scrollDirection == "top" && container.scrollTop < 300
                ) || (
                    props.scrollDirection == "bottom" && ((container.scrollTop + container.clientHeight) > (container.scrollHeight - 300))
                );
                if (needLoad) {
                    loadMore(true);
                }
            }
        };
        setTimeout(() => {
            if (scrollHandler.value) {
                props.scrollContainer.addEventListener("scroll", scrollHandler.value, {passive: true});
            }
        }, 100);

    } else {
        console.error("Не передан scrollContainer");
    }

});

onBeforeUnmount(() => {
    if (props.scrollContainer) {
        props.scrollContainer.removeEventListener("scroll", scrollHandler.value);
        scrollHandler.value = null;
    } else {
    }
});


function reload() {
    if (!loading.value) {
        loadAvailable.value = true;
        props.items.splice(0, props.items.length);
        loadMore();
    }
}

function startLoading() {
    loading.value = true;
}

function stopLoading() {
    itemsCountHandlerEnabled.value = true;
    loading.value = false;
}

let instance = getCurrentInstance().proxy;

async function loadMore(onScroll?: boolean) {
    if (!loading.value && loadAvailable.value && props.scrollContainer && instance.$el.parentNode) {
        startLoading();
        try {
            let previousHeight = props.scrollContainer.scrollHeight;
            //debugger;
            let newItems = await props.loadMethod();
            let scrollToBottom = itemsCount.value == 0 || (isFirstLoad && !onScroll);
            if (props.scrollContainer && scrollHandler.value) {
                isFirstLoad = false;
                let currentScroll = props.scrollContainer.scrollTop;
                let items = props.items;
                itemsCountHandlerEnabled.value = false;
                if (props.scrollDirection == "top") {
                    items.splice(0, 0, ...newItems);
                } else {
                    items.push(...newItems);
                }

                loadAvailable.value = newItems.length > 0;
                if (loadAvailable.value) {
                    nextTick(async () => {
                        if (props.scrollDirection == "top") {
                            if (scrollToBottom) {
                                await Delay.make(10);
                                await WindowHelper.scrollToBottom(props.scrollContainer, 0);
                            } else {
                                let newHeight = props.scrollContainer.scrollHeight;
                                let scroll = currentScroll + newHeight - previousHeight;
                                await WindowHelper.scrollTo(scroll, props.scrollContainer, 0);
                            }
                        }
                        try {
                            await Delay.make(500, "infinite-scroll-top-container");
                            nextTick(() => {
                                stopLoading();
                                if (scrollHandler.value) {
                                    scrollHandler.value();
                                }
                            });
                        } catch (e) {
                            stopLoading();
                        }
                    });
                } else {
                    stopLoading();
                }
            } else {
                stopLoading();
            }
        } catch (e) {
            stopLoading();
            console.error(e);
        }
    }
}

__expose<InfiniteScrollContainerExposeInterface>({
    reload
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.loadPreviousLabel)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({
                visibility: _unref(loadAvailable) ? 'visible' : 'hidden'
            }),
          class: "text-center"
        }, [
          _createVNode(_component_el_button, {
            link: "",
            onClick: loadMore,
            disabled: _unref(loading)
          }, {
            default: _withCtx(() => [
              _createVNode(FontAwesomeIcon, {
                icon: "sync-alt",
                class: _normalizeClass({
                        'fa-spin': true,
                        'mr-1': true,
                        invisible: !_unref(loading)
                    })
              }, null, 8, ["class"]),
              _createTextVNode(" " + _toDisplayString(__props.loadPreviousLabel) + " ", 1),
              _createVNode(FontAwesomeIcon, {
                icon: "sync-alt",
                class: _normalizeClass({
                        'ml-1': true,
                        invisible: true
                    })
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 4))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {
      empty: !_unref(loading) && !_unref(itemsCount),
      loading: _unref(loading)
    })
  ]))
}
}

})